import { Card as MuiCard, CardProps } from '@material-ui/core';
import React from 'react';

export function Card(props: CardProps): React.ReactElement {
  const { raised = true, ...cardProps } = props;

  return <MuiCard raised={raised} {...cardProps} />;
}
